import { Action, initialState, State, Audio } from 'store/store';

// TODO - update with type for audio

export const controlAudio = (
  state: State = initialState,
  { data }: Action
): State => {
  // if data is anything falsey or an empty object
  if (!data || !Object.keys(data).length) {
    return {
      ...state,
      audio: data as Audio,
    };
  }

  const newAudio = {
    ...state.audio,
    ...(data as Audio),
  };

  // console.log('controlAudio :', newAudio);

  const nextState = {
    ...state,
    audio: { ...newAudio },
  };

  return nextState as State;
};
